// Labels for the live chat states and outcomes stored by the server (app/services/live_chat.py)

const STATUS_LABELS = {
  requested: "Waiting",
  active: "Live",
  claimed: "Live",
  resolved: "Resolved",
  auto_resolved: "Auto-resolved",
  timed_out: "No agent in time",
  unavailable: "No agent online",
  closed: "Closed",
};

const OUTCOME_LABELS = {
  resolved: "Resolved by agent",
  auto_resolved: "Auto-resolved (idle)",
  wait_timeout: "No agent accepted in time",
  no_agent_online: "No agent online",
  visitor_ended: "Ended by visitor",
};

export const liveChatStatusLabel = (status) => STATUS_LABELS[status] || "";

export const liveChatOutcomeLabel = (reason) => OUTCOME_LABELS[reason] || reason || "";

export const formatDuration = (seconds) => {
  if (seconds === null || seconds === undefined || Number.isNaN(Number(seconds))) return "";
  const s = Math.max(0, Math.round(Number(seconds)));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
};
